
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateEquipmentlogCheckinDtoFormGroup() {
return new FormGroup({
    equipmentId: new FormControl<number | undefined>(undefined, [Validators.required]),
    stocklocationId: new FormControl<number | undefined>(undefined),
    statusId: new FormControl<number | undefined>(undefined),
    createdBy: new FormControl<number | undefined>(undefined),
    equipmentlogtypeId: new FormControl<number | undefined>(1, [Validators.required]),
    title: new FormControl<string | undefined>('Check-In', [Validators.maxLength(100)]),
    text: new FormControl<string | undefined>(undefined),
    childrenIds: new FormControl<Array<number> | undefined>([]),
    documentIds: new FormControl<Array<number> | undefined>([]),
})
;
}
      